import ContactManager from "./ContactManagerModalContainer";

export default ContactManager;
